import OfflineVideosPage from "@/pages/OfflineVideosPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/_app/offline-videos")({
	component: OfflineVideosPage,
	validateSearch: (search: Record<string, unknown>) => {
		return {
			productType: (search?.['productType'] as "training" | "webinar" | "course") || "training"
		};
	},
});

